export const invites = () => ({
    inviteData: () => `/invites/user_data` as const,
    single: (inviteCode: string) => ({
        show: () => `/invites/${inviteCode}`,
    }),
    create: () => `/invites`,
    accept: (inviteCode: string) => `/invites/${inviteCode}/accept`,
});
